import { ReactElement } from 'react';

import routes from '~/router/routes';

import { UserRolePermission } from '~/contexts/role-authentication';

// Base menu item properties
type BaseMenuItem = {
  id: string;
  title: string;
  icon?: ReactElement;
  roles?: UserRolePermission | null | undefined;
};

// Menu item with link (onClick is optional)
type MenuItemWithLink = BaseMenuItem & {
  link: string;
  onClick?: (onClickHandler: () => void) => void;
  subItems?: MenuItemDef[];
};

// Menu item with onClick (link is optional)
type MenuItemWithOnClick = BaseMenuItem & {
  onClick: (onClickHandler: () => void) => void;
  link?: string;
  subItems?: MenuItemDef[];
};

// Union type that requires either link or onClick
export type MenuItemDef = MenuItemWithLink | MenuItemWithOnClick;

export const QAMenu: MenuItemDef[] = [
  {
    id: 'quick_actions',
    title: 'Quick Actions',
    link: '/',
    subItems: [
      {
        id: 'checkins',
        title: 'Check-Ins',
        link: `${routes.quickActions.checkins.root}`,
      },
      {
        id: 'take_payment',
        title: 'Create Charge',
        onClick: (onClickHandler: () => void) => {
          onClickHandler();
        },
      },
      {
        id: 'add_contact',
        title: 'Add Contact',
        link: `${routes.quickActions.addContact.root}`,
      },
    ],
  },
];

export const menu = [
  {
    id: 'members',
    title: 'Contacts',
    link: `/${routes.members.root}`,
    subItems: [
      {
        id: 'members',
        title: 'Contacts',
        link: `/${routes.members.members.root}`,
      },
    ],
  },
  {
    id: 'schedule',
    title: 'Schedule',
    link: '/schedule',
    subItems: [
      {
        id: 'schedule',
        title: 'Schedule',
        link: '/schedule',
      },
    ],
  },
  {
    id: 'operations',
    title: 'Operational',
    link: `/${routes.operations.root}`,
    subItems: [
      {
        id: 'staff',
        title: 'Staff',
        link: '/staff',
      },
      {
        id: 'sessions',
        title: 'Session Access',
        link: `/${routes.operations.sessions.root}`,
      },
      {
        id: 'plan-management',
        title: 'Plan Management',
        link: `/${routes.operations.plans.root}`,
      },
    ],
  },
  {
    id: 'reports',
    title: 'Reports',
    link: '/reports',
    subItems: [
      {
        id: 'at-risk-attendance',
        title: 'At Risk Attendance',
        link: '/at-risk-attendance',
      },
      {
        id: 'challenge-conversion-detail',
        title: 'Challenge Conversion Detail',
        link: '/challenge-conversion-detail',
      },
    ],
  },
];

export const filterMenuByRole = (
  menu: MenuItemDef[],
  isGranted: (role: UserRolePermission) => boolean,
): MenuItemDef[] => {
  return menu
    .map((item) => {
      // If no roles are defined, the item is accessible to all users
      if (!item.roles || isGranted(item.roles)) {
        // Recursively filter sub-items
        const filteredSubItems = item.subItems ? filterMenuByRole(item.subItems, isGranted) : undefined;

        // Return the item with filtered sub-items
        return { ...item, subItems: filteredSubItems };
      }

      // If roles are defined and the user doesn't have access, exclude the item
      return null;
    })
    .filter(Boolean) as MenuItemDef[]; // Remove items that are null
};

export default menu;
